// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1_uyF","cls2":"PaperContainer-cls2__7G PaperContainer-cls1_uyF"};